import { icons } from 'lucide-angular';
import { SP_ICONS } from '../icons/sp-icons';

const toPascalCase = (str: string) => 
  str.split('-')
     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
     .join('');

const getSafeIconName = (name?: string) => {
  if (!name) return 'circle-fading-plus';
  
  // Check if it's a custom icon
  if (SP_ICONS[name]) return name;

  // Check if it's a valid Lucide icon name (PascalCase check)
  const pascalName = toPascalCase(name);
  // @ts-ignore
  return icons[pascalName] || icons[name] ? name : 'circle-fading-plus';
};

export default getSafeIconName;
